import { render, staticRenderFns } from "./SettingApprovalChain.vue?vue&type=template&id=5388abb4&scoped=true&"
import script from "./SettingApprovalChain.vue?vue&type=script&lang=js&"
export * from "./SettingApprovalChain.vue?vue&type=script&lang=js&"
import style0 from "./SettingApprovalChain.vue?vue&type=style&index=0&id=5388abb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5388abb4",
  null
  
)

export default component.exports